import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import Tabs from "react-bootstrap/esm/Tabs";
import Tab from "react-bootstrap/esm/Tab";

import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";
import axiApi from "ApiCaller";
import CollectionsListFilters from "./collections-analysis/CollectionsListFilters";
import ContainersListTable from "./collections-analysis/ContainersListTable";
import ContainersSavingListTable from "./collections-analysis/ContainersSavingListTable";
import IslandsListTable from "./collections-analysis/IslandsListTable";
import IslandsSavingListTable from "./collections-analysis/IslandsSavingListTable";
import RangeListTable from "./collections-analysis/RangeListTable";
import ContainersDailyFillingTable from "./collections-analysis/ContainersDailyFillingTable";
import ContainersDailyQuarterFillingTable from "./collections-analysis/ContainersDailyQuarterFillingTable";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import ButtonsDays from "components/datestimes/ButtonsDays";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";
import moment from "moment-timezone";

const OrderModel = function () {
    return {
        param: {},
        events: [],
        getParams: function () {
            const keys = Object.keys(this.param);
            if (keys.length === 0) return {};
            // -
            return {o: `${this.param.attr}:${this.param.direction}`};
        },
        clickOrder: function () {
            this.events.forEach((event) => event());
            // -
            this.launchOrder();
        },
        launchOrder: function () {},
        reset: function () {
            this.param = {};
            this.events = [];
        },
    };
};

const ReportCollectionsAnalysis = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _TC} = useCustomTranslation(translations);
    const title = "Analisis Recogidas";
    const bread = [
        {name: _Tr("labels.reports"), url: "/reports/", current: false},
        {name: title, current: true},
    ];

    const itemsRef = useRef([]);
    const filters = useRef(new FilterModel());
    const pagerRef = useRef(new PagerModel());
    const orderRef = useRef(new OrderModel());

    const [itemsShown, setItemsShown] = useState([]);
    const [dateHeaders, setDateHeaders] = useState([]);
    const [islands, setIslands] = useState([]);
    const [days, setDays] = useState("");
    const [dailyPctFill, setDailyPctFill] = useState({});
    const [dailyQuarterFill, setDailyQuarterFill] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [tab, setTab] = useState("containers");
    const [selectedDays, setSelectedDays] = useState([]);
    const [targetPercentage, setTargetPercentage] = useState(100);
    const [daysPerYear, setDaysPerYear] = useState(365);
    const [actualCollections, setActualCollections] = useState(null);

    const estimatedCollections = selectedDays.length > 0 ? Math.round(selectedDays.length * (daysPerYear / 7)) : 0;

    useEffect(() => {
        if (estimatedCollections > 0) {
            setActualCollections(estimatedCollections);
        }
    }, [estimatedCollections]);

    const [params, setParams] = useState({
        groups: [],
        islands: [],
        routes: [],
        zones: [],
    });

    useEffect(() => {
        setIsLoading(true);
        document.title = title;
        pagerRef.current.active = true;
        pagerRef.current.handleCallApi = () => {
            applyFilters();
        };
        orderRef.current.launchOrder = () => {
            pagerRef.current.reset();
            applyFilters();
        };
        axiApi
            .get("/api/reports/containers/filters/")
            .then((resp) => {
                let params_ = {...params};
                params_.groups = [...resp.data.groups];
                params_.islands = [...resp.data.islands];
                params_.routes = [...resp.data.routes];
                params_.zones = [...resp.data.zones];
                setParams(params_);
            })
            .finally(() => setIsLoading(false));
    }, []);

    const applyFilters = async () => {
        setIsLoading(true);
        setItemsShown([]);
        setIslands([]);
        setDays("");
        pagerRef.current.paging.active = false;
        setterDateHeaders();
        const payload = {
            ...filters.current.chosen,
            target_percentage: targetPercentage,
            days_per_year: daysPerYear,
        };

        try {
            const respItems = await axiApi.post("/api/reports/analysis/collections/", payload, {
                params: {...pagerRef.current.paging.getParams(), ...orderRef.current.getParams()},
            });
            if (respItems.data && "items" in respItems.data && respItems.data.items.length) {
                itemsRef.current = [...respItems.data.items];
                setDays(respItems.data.days);
                pagerRef.current.paging.update(respItems.data.pager);
                pagerRef.current.paging.active = true;
                payload.uuids = respItems.data.items.map((item) => item.uuid);
                const respMeasuresHour = await axiApi.post("/api/reports/analysis/collections/measures/hour/", payload);
                if (respMeasuresHour.data && "measures" in respMeasuresHour.data) {
                    calculateAvgDiffs(respMeasuresHour.data.measures, respItems.data.items);
                }
                const respMeasuresQuarter = await axiApi.post("/api/reports/analysis/collections/measures/quarter/", payload);
                if (respMeasuresQuarter.data && "measures" in respMeasuresQuarter.data) {
                    setDailyQuarterFill(respMeasuresQuarter.data.measures);
                }
                setItemsShown([...respItems.data.items]);
                setIslands(respItems.data.islands || []);
            } else {
                setItemsShown([]);
                setIslands([]);
                setDays("");
                pagerRef.current.paging.active = false;
            }
        } catch (err) {
            console.error(err);
        }
        setIsLoading(false);
    };

    /**
     * Calcula la media de llenado diario
     * Ademas de calcular el porcentaje de llenado diarios.
     * @param measures
     * @param items_
     */
    const calculateAvgDiffs = (measures, items_) => {
        const dailyValues = {};

        for (const item of items_) {
            const values = measures[item.uuid];

            if (!values?.length) continue;
            dailyValues[item.uuid] = {
                avg: 0,
                dates: {},
            };

            let total = 0;
            let count = 0;

            for (let i = 0; i < values.length; i++) {
                const current = values[i];
                const next = values[i + 1];

                if (!next) continue;

                const discharge = item.daily_levels?.[current.date];

                if (discharge && discharge.value > 0) {
                    const dischargeDiff = (discharge.value - current.value) + next.value;

                    dailyValues[item.uuid].dates[current.date] = Math.ceil(dischargeDiff > 0 ? dischargeDiff : 0);
                    if (dischargeDiff > 0) {
                        total += dischargeDiff;
                    }
                    count += 1;
                    continue;
                }

                const diff = Math.ceil(next.value - current.value);
                dailyValues[item.uuid].dates[current.date] = diff > 0 ? diff : 0;
                if (diff > 0) {
                    total += diff;
                }
                count += 1;
            }

            dailyValues[item.uuid].avg = count ? Math.ceil(total / count) : 0;
        }
        setDailyPctFill(dailyValues);
    };

    const setterDateHeaders = () => {
        if (filters && filters.current && filters.current.chosen && filters.current.chosen.start && filters.current.chosen.end) {
            const start = moment(filters.current.chosen.start, "DD/MM/YYYY");
            const end = moment(filters.current.chosen.end, "DD/MM/YYYY");
            const dates = [];
            while (start.isSameOrBefore(end)) {
                const m = start.clone();
                const dayVal = m.day().toString();
                if (selectedDays && selectedDays.length > 0 && !selectedDays.includes(dayVal)) {
                    start.add(1, "day");
                    continue;
                }
                dates.push({
                    day: start.date(),
                    month: start.month(),
                    date: start.format("DD-MM-YYYY"),
                    label: start.format("DD MMM").toLowerCase(),
                });
                start.add(1, "day");
            }
            setDateHeaders(dates);
        }
    };

    const onClickApplyFilters = () => {
        pagerRef.current.reset();
        orderRef.current.reset();
        applyFilters();
    };

    const handleChangeSelectedDays = (days_) => {
        setSelectedDays(days_);
        if (days_) {
            filters.current.chosen["selected_days"] = days_;
        } else {
            delete filters.current.chosen["selected_days"];
        }
        onClickApplyFilters();
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <div className="row">
                <div className="col-12">
                    <h3 className="mt-2">{title}</h3>
                    <CollectionsListFilters
                        filters={filters}
                        params={params}
                        onClickApplyFilters={onClickApplyFilters}
                        downloadFilters={() => {}}
                        setItemsShown={setItemsShown}
                    />
                </div>
            </div>
            <div className="row align-items-end mb-2">
                <div className="col-auto">
                    <label className="form-label mb-1 small">{_TC("inputs.collectionDays")}</label>
                    <ButtonsDays days={selectedDays} setDays={handleChangeSelectedDays} display={true} />
                </div>
                <div className="col-auto">
                    <label className="form-label mb-1 small">{_TC("inputs.targetPercentage")}</label>
                    <input
                        type="number"
                        className="form-control form-control-sm"
                        style={{width: "80px"}}
                        min="1"
                        max="100"
                        value={targetPercentage}
                        onChange={(e) => setTargetPercentage(Math.max(1, Math.min(100, parseInt(e.target.value) || 1)))}
                    />
                </div>
                <div className="col-auto">
                    <label className="form-label mb-1 small">{_TC("inputs.daysYear")}</label>
                    <input
                        type="number"
                        className="form-control form-control-sm"
                        style={{width: "80px"}}
                        min="1"
                        value={daysPerYear}
                        onChange={(e) => setDaysPerYear(Math.max(1, parseInt(e.target.value) || 1))}
                    />
                </div>
                <div className="col-auto">
                    <label
                        className="form-label mb-1 small"
                        title={`Est.: ${estimatedCollections} ${_TC("tables.anualCollections").toLowerCase()}`}>
                        {_TC("tables.anualCollections")}
                    </label>
                    <input
                        type="number"
                        className="form-control form-control-sm"
                        style={{width: "90px"}}
                        min="1"
                        placeholder={String(estimatedCollections)}
                        value={actualCollections ?? ""}
                        onChange={(e) => {
                            const val = e.target.value;
                            if (val === "") {
                                setActualCollections(null);
                            } else {
                                setActualCollections(Math.max(1, parseInt(val) || 1));
                            }
                        }}
                    />
                </div>
                <div className="col">
                    <TopBarPagination pagerModel={pagerRef.current} stickyTopValue="72px" />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Tabs activeKey={tab} id="analysis-tabs" onSelect={setTab} className="mb-3 mt-1">
                        <Tab eventKey="containers" title={_TC("tabs.containers")}>
                            <LoaderSpinner isLoading={isLoading}>
                                <ContainersListTable itemsShown={itemsShown} dateHeaders={dateHeaders} orderRef={orderRef} />
                            </LoaderSpinner>
                        </Tab>
                        <Tab eventKey="daily" title={_TC("tabs.dailies")}>
                            <LoaderSpinner isLoading={isLoading}>
                                <ContainersDailyFillingTable
                                    itemsShown={itemsShown}
                                    dateHeaders={dateHeaders}
                                    dailyPctFill={dailyPctFill}
                                />
                            </LoaderSpinner>
                        </Tab>
                        <Tab eventKey="quarter" title={_TC("tabs.quarter")}>
                            <LoaderSpinner isLoading={isLoading}>
                                <ContainersDailyQuarterFillingTable
                                    itemsShown={itemsShown}
                                    dateHeaders={dateHeaders}
                                    dailyQuarterFill={dailyQuarterFill}
                                />
                            </LoaderSpinner>
                        </Tab>
                        <Tab eventKey="islands" title={_TC("tabs.islands")}>
                            <LoaderSpinner isLoading={isLoading}>
                                <IslandsListTable itemsShown={islands} dateHeaders={dateHeaders} />
                            </LoaderSpinner>
                        </Tab>
                        <Tab eventKey="savings-containers" title={_TC("tabs.savingsContainers")}>
                            <LoaderSpinner isLoading={isLoading}>
                                <ContainersSavingListTable
                                    itemsShown={itemsShown}
                                    targetPercentage={targetPercentage}
                                    actualCollections={actualCollections}
                                />
                            </LoaderSpinner>
                        </Tab>
                        <Tab eventKey="savings-islands" title={_TC("tabs.savingsIslands")}>
                            <LoaderSpinner isLoading={isLoading}>
                                <IslandsSavingListTable
                                    itemsShown={islands}
                                    targetPercentage={targetPercentage}
                                    actualCollections={actualCollections}
                                />
                            </LoaderSpinner>
                        </Tab>
                        <Tab eventKey="ranges" title={_TC("tabs.ranges")}>
                            <LoaderSpinner isLoading={isLoading}>
                                <RangeListTable
                                    itemsShown={itemsShown}
                                    dateHeaders={dateHeaders}
                                    targetPercentage={targetPercentage}
                                />
                            </LoaderSpinner>
                        </Tab>
                    </Tabs>
                </div>
            </div>
        </>
    );
};
export default ReportCollectionsAnalysis;
